<template>
  <div>
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <div class="navbar-minimize">
          <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
              <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
            </button>
        </div>
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar bar1"></span>
              <span class="icon-bar bar2"></span>
              <span class="icon-bar bar3"></span>
            </button>
        </div>
        <div class="collapse navbar-collapse">
          <form class="navbar-form navbar-left navbar-search-form" role="search">
          </form>
          <ul class="nav navbar-nav navbar-right">
            <li class="open">
              <router-link to="/admin/stats" class="dropdown-toggle  btn-magnify" data-toggle="dropdown">
              </router-link>
            </li>
            <li>
              <router-link to="/admin/overview" class="btn-rotate">
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div v-if="compartilhado.assinatura.mostraBarra" class="top-navbar alert alert-danger alert-with-icon">
      <span data-notify="template">
        {{compartilhado.assinatura.mensagem}}
        <span v-if="compartilhado.assinatura.mostraLink">Deseja <router-link :to="{ name: 'meu-perfil' }" class="assinar">assinar</router-link>?</span>
      </span>
    </div>
  </div>
</template>
<script>
  import Compartilhamento from '@/services/Compartilhamento'
  export default {
    data () {
      return {
        compartilhado: {
          assinatura: Compartilhamento.assinatura.dados
        },
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }
</script>
<style lang="scss">
@media (min-width: 992px){
  .navbar{
    display: none;
  }
}
.top-navbar {
  &.alert {
    padding-left: 40px;
    margin-bottom: -20px;
    background-color: #eb5e28;
    color: #fff;

    span {
      font-family: 'Muli', Arial, sans-serif;
      font-weight: bolder;

      .assinar {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue